import type { AxiosInstance } from "axios";
import type {
  SendSmsRequest,
  SendSmsResponse,
  VerifySmsRequest,
  VerifySmsResponse,
} from "../../types/sms";

// Re-export types
export type {
  SendSmsRequest,
  SendSmsResponse,
  VerifySmsRequest,
  VerifySmsResponse,
} from "../../types/sms";

/**
 * SMS API 함수들을 생성합니다.
 */
export function createSmsApi(client: AxiosInstance) {
  return {
    /**
     * SMS 인증번호 전송
     */
    sendSms: async (data: SendSmsRequest): Promise<SendSmsResponse> => {
      const response = await client.post<SendSmsResponse>("/sms/send", data);
      return response.data;
    },

    /**
     * SMS 인증번호 확인
     */
    verifySms: async (data: VerifySmsRequest): Promise<VerifySmsResponse> => {
      const response = await client.post<VerifySmsResponse>(
        "/sms/verify",
        data
      );
      return response.data;
    },
  };
}
